import React, { memo, useCallback, useMemo } from 'react';
import { Button, ButtonProps } from '@betty/moonlight';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import { selectAccount, selectAccountDataState } from '@betty/account/state';
import { TextProps } from '@betty/moonlight/lib/common/Text/Text.types';
import { STATUS_CONFIG } from './MainHeaderCTA.constants';

function HeaderCTA(props: ButtonProps) {
  const dispatch = useDispatch();
  const account = useSelector(selectAccount);
  const accountDataState = useSelector(selectAccountDataState);

  const config = useMemo(() => {
    const status = account?.status;
    return status && STATUS_CONFIG[status]
      ? STATUS_CONFIG[status]
      : STATUS_CONFIG.DEFAULT;
  }, [account?.status]);

  const textProps = useMemo<Pick<TextProps, 'locKey' | 'locNS'>>(
    () => config.textProps,
    [config],
  );

  const onPress = useCallback(() => {
    config.action(dispatch);
  }, [dispatch, config]);

  return (
    <Button
      {...textProps}
      loading={accountDataState === 'idle' || accountDataState === 'pending'}
      onPress={onPress}
      flex={1}
      {...props}
    />
  );
}

export default memo(HeaderCTA);
